import React from 'react'

const STATUS_NEGATIVACAO = {
  0: { label: 'Em negativação', className: 'badge badge-info text-white' },
  1: { label: 'Negativado', className: 'badge badge-warning text-dark' },
  2: { label: 'Em desnegativação', className: 'badge badge-secondary' },
}

export default function NegativacaoStatusBadge({ status, className = '' }) {
  if (status === null || status === undefined || status === 3) {
    return null
  }

  const config = STATUS_NEGATIVACAO[status]
  if (!config) {
    return null
  }

  return <span className={`${config.className} ${className}`.trim()}>{config.label}</span>
}
